<div class="floating-container">
  <div
    class="floating-overlay"
    [style.width.px]="panelWidth"
    [style.height.px]="panelHeight"
    [style.left.px]="panelLeft"
    [style.top.px]="panelTop"
  >
    <!-- Resize handles -->
    <div
      class="resize-handle resize-handle-right"
      (mousedown)="startResize($event, 'right')"
    ></div>
    <div
      class="resize-handle resize-handle-bottom"
      (mousedown)="startResize($event, 'bottom')"
    ></div>
    <div
      class="resize-handle resize-handle-corner"
      (mousedown)="startResize($event, 'corner')"
    ></div>

    <div class="floating-header" (mousedown)="startDrag($event)">
      <div class="header-title">
        <mat-icon class="header-icon material-symbols-outlined">{{
          headerIcon
        }}</mat-icon>
        <h3>{{ title }}</h3>
      </div>
      @if(title !== "AI Assistant"){
      <button
        class="close-button"
        (click)="onClose()"
        (mousedown)="$event.stopPropagation()"
      >
        ×
      </button>
      }
    </div>
    <div class="floating-content">
      @if(template){
      <ng-container>
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </ng-container>
      }
    </div>
  </div>
</div>
